import { useWizard } from '@portals/framework';

import { SignupWizardContextDataType, StepIdEnum } from './wizard.types';

export function useSignUpWizard() {
  return useWizard<SignupWizardContextDataType, StepIdEnum>();
}
